import { render, staticRenderFns } from "./MemoriaCalculoAcoesBtn.vue?vue&type=template&id=42f0abe6&scoped=true&"
import script from "./MemoriaCalculoAcoesBtn.vue?vue&type=script&lang=js&"
export * from "./MemoriaCalculoAcoesBtn.vue?vue&type=script&lang=js&"
import style0 from "./MemoriaCalculoAcoesBtn.vue?vue&type=style&index=0&id=42f0abe6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f0abe6",
  null
  
)

export default component.exports